import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectLoading, selectLocations } from './store/slice'
import { getLocationThunk } from './store/thunk'

let cacheKey = null

const useGetLocation = ({ disableCallApi }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.LOCATION))
  const locations = useSelector(selectLocations)

  useEffect(() => {
    if (cacheKey !== locale && !disableCallApi) {
      cacheKey = locale
      dispatch(getLocationThunk())
    }
  }, [locale])

  return {
    loading,
    locations,
  }
}

export default useGetLocation
